import React from 'react';
import ProductMarkers from '../ProductMarkers';
const MarketingMarker = ({ marketingMarkerText, marketingMarkerType, brandName, isExternalBrand, markers, variant = 'hm', }) => {
    const getMarkers = () => {
        const shouldShowBrandName = !!brandName && isExternalBrand;
        if (shouldShowBrandName) {
            return [
                {
                    text: brandName,
                    type: 'custom',
                },
            ];
        }
        if (marketingMarkerText && marketingMarkerType) {
            return marketingMarkerText.split(',').map((marker) => ({
                text: marker,
                type: marketingMarkerType,
            }));
        }
        if (markers === null || markers === void 0 ? void 0 : markers.length) {
            return markers;
        }
        return undefined;
    };
    const internalMarkers = getMarkers();
    if (internalMarkers === null) {
        return null;
    }
    return React.createElement(ProductMarkers, { variant: variant, markers: internalMarkers });
};
export default MarketingMarker;
//# sourceMappingURL=MarketingMarker.js.map